// extracted by mini-css-extract-plugin
export var cardLayout = "_8d-1";
export var paginationContainer = "_8d-0";